<template>
    <div class="inner technology">
      <Pagetitle/>
 
    <section class="section lm-services bg pt-100 pb-50">
      <div class="container wd-container">
        <div class="sec-title text-center" data-aos="fade-down" data-aos-delay="50">
          <h2>Techstacks that We do</h2>
          <p>Planning, designing, developing, and managing projects.<br> With one digital team, you can take advantage of the power of specialization.</p>
        </div>
        <div class="row flex-md-row-reverse">
            <div class="col-lg-6 col-md-6 col-12">
                <img src="/img/technology/tools.svg" data-aos="fade-left" data-aos-delay="300" class="img-fluid" :alt=metadata.image1_alt_name>
            </div>
            <div class="col-lg-6 col-md-6 col-12 d-flex align-items-center">
              <div class="ctn-box" data-aos="fade-right" data-aos-delay="80">
                <div class="sec-title">
                  <h2>Tools and Technologies</h2>
                </div>
                <p>We can help you improve your in-house development with our experienced developers.</p>
                <p>It is exhausting and takes time to build a good in-house product team. You may need developers, designers and/or other specialists with the right experience in the field of technologies, frameworks, tools and platform development.</p>
                <p><strong>We take care of the entire development process for you.</strong></p>
                <p>A high-quality and user-friendly web application can be developed using a variety of methods, technologies, and tools.</p>
              </div>
            </div>
          </div>
      </div>
    </section>
    <section class="section lm-services bg pt-50 pb-50">
      <div class="container wd-container">
        <div class="row web-development flex-md-row-reverse">
            <div class="col-lg-6 col-md-6 col-12">
                <div class="ctn-box">
                    <div class="sec-title" data-aos="fade-down" data-aos-delay="50">
                      <h2>Frontend Development.</h2>
                    </div>
                    <p data-aos="fade-right" data-aos-delay="50">We use framework in developing stunning, engaging, successful user interfaces using in demand front end technologies and industry trends. Front-end frameworks such as React.js, Vue.js, and Angular.js are used for building the user interface (UI) of web applications. These frameworks provide developers with pre-built UI components and libraries that they can use to create interactive and responsive web pages.</p>
                    <div class="technology-tools d-flex justify-content-center flex-wrap">
                        <a class="technology-item" data-aos="fade-up" data-aos-duration="1000">
                          <img src="/img/technology/frontend/pwa.png" alt="html">
                          <div class="technology-name">PWA</div>
                        </a>
                        
                        
                          <a class="technology-item" data-aos="fade-up" data-aos-duration="1000">
                              <img src="/img/technology/frontend/angular.png" alt="html">
                              <div class="technology-name">Angular</div>
                          </a>
                        
                        
                          <a class="technology-item" data-aos="fade-up" data-aos-duration="1000">
                              <img src="/img/technology/frontend/reactjs.png" alt="html">
                              <div class="technology-name">React</div>
                          </a>
                        
                        
                          <a class="technology-item" data-aos="fade-up" data-aos-duration="1000">
                              <img src="/img/technology/frontend/vue.png" alt="html">
                              <div class="technology-name">Vue</div>
                          </a>
                        
                    </div>
                    
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12 d-flex align-items-center">
              <div class="ctn-box mt-5 mt-md-0">
                <div class="sec-title" data-aos="fade-down" data-aos-delay="50">
                  <h2>Backend Development.</h2>
                </div>
                <!-- <div class="sub-title">
                  <h3>Full-service IT support</h3>
                </div> -->
                <div class="content-box" data-aos="fade-right" data-aos-delay="50">
                  <p>Back-end frameworks like Node.Js and Laravel are used for building the server-side logic of web applications. It is used to create lightweight and scalable web applications. With the right combination of frameworks, our skilled developers create customized experiences for users that are tailored to their needs and preferences. Our development team creates powerful back-end solutions, allowing apps to handle heavy user loads with minimal glitches.</p>
                </div>
                <div class="technology-tools d-flex justify-content-center flex-wrap">
                    <a class="technology-item" data-aos="fade-up" data-aos-duration="1000">
                        <img src="/img/technology/backend/php.png" alt="html">
                        <div class="technology-name">PHP</div>
                    </a>
                    <a class="technology-item" data-aos="fade-up" data-aos-duration="1000">
                        <img src="/img/technology/backend/node.webp" alt="html">
                        <div class="technology-name">Node</div>
                    </a>
                    <a class="technology-item" data-aos="fade-up" data-aos-duration="1000">
                        <img src="/img/technology/backend/laravel.png" alt="html">
                        <div class="technology-name">Laravel</div>
                    </a>
                    <a class="technology-item" data-aos="fade-up" data-aos-duration="1000">
                        <img src="/img/technology/backend/python.png" alt="html">
                        <div class="technology-name">Python</div>
                    </a>
                </div>
              </div>
            </div>
          </div>
      </div>
    </section>

    <section class="section lm-services bg pt-50 pb-100">
      <div class="container wd-container">
        <!-- <div class="sec-title text-center">
          <h2 data-aos="fade-up" data-aos-delay="50">What We Do.</h2>
          <p data-aos="fade-down" data-aos-delay="50">We’re best placed to help build your online business: taking the time to learn about your company,<br> industry and commercial challenges</p>
        </div> -->
        <div class="row mobile-app-developement">
            
            <div class="col-lg-6 col-md-6 col-12 d-flex">
              <div class="ctn-box">
                <div class="sec-title pb-1" data-aos="fade-up" data-aos-delay="50">
                  <h2>Mobile Apps Development.</h2>
                </div>
                <div class="content-box" data-aos="fade-up" data-aos-delay="50">
                    <p>You know what nowadays Web applications are not only on your computer. You open them with a web browser, so you always have access with the right credentials, anywhere and on any device.</p>
                    <p>No I won't say as we're top leading mobile app development agency but we can assure you your dream project would in on safe hand.</p>
                    <p>We've holds a remote & in-house team of well versed iOS, Android and flutter apps developers who have been working with SMBs, startups and B2B agencie, no matter which industies you're from our aim is to provide you complete development solutions.</p>
                </div>
                <div class="mobiles-animation">
                  <img data-aos="fade-right" data-aos-delay="500" src="/img/technology/mobile/mobile-app-bg.png" :alt=metadata.image2_alt_name>
                  <div class="mobile-tech-img">
                    <figure class="mobile-img one" >
                      <img data-aos="fade-up" data-aos-delay="1250" src="/img/technology/mobile/mobile-app-2.png" :alt=metadata.image4_alt_name>
                    </figure>
                    <figure class="mobile-img two">
                      <img data-aos="fade-down" data-aos-delay="750" src="/img/technology/mobile/mobile-app-1.png" :alt=metadata.image3_alt_name>
                    </figure>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-md-6 col-12">
                <div class="image-section d-flex justify-content-center">
                    <div class="technology-tools d-flex flex-column" data-aos="fade-down" data-aos-delay="50">
                        <router-link to="/android-app-development" class="technology-item">
                            <img src="/img/technology/mobile/android-icon.png" alt="html">
                            <div class="technology-name">Android</div>
                            <div class="text">We do Android Apps Development for Smartphones, Tablets, Android Wear, and Android TV from the scratch.</div>
                        </router-link>
                        <router-link to="/ios-app-development" class="technology-item">
                            <img src="/img/technology/mobile/apple-icon.png" alt="html">
                            <div class="technology-name">iOS</div>
                            <div class="text">Creating iOS apps that are secure, reliable, and tailored to the needs and preferences of users.</div>
                        </router-link>
                    </div>
                    <div class="technology-tools d-flex flex-column mt-4" data-aos="fade-up" data-aos-delay="50">
                        <a class="technology-item">
                            <img src="/img/technology/mobile/ionic-icon.png" alt="html">
                            <div class="technology-name">Ionic</div>
                            <div class="text">Creating interactive and incredible hybrid and cross-platform app for iOS and Android with remarkable efficiency.</div>
                        </a>
                        <router-link to="/flutter-app-development" class="technology-item">
                            <img src="/img/technology/mobile/flutter-icon.png" alt="html">
                            <div class="technology-name">Flutter</div>
                            <div class="text">We take on projects and tasks independently for flutter app development.</div>
                        </router-link>
                    </div>
                    
                </div>
            </div>
          </div>
          <div class="row mt-5">
            <div class="col-lg-6 col-md-6 col-12 d-flex align-items-center">
              <div class="ctn-box mt-4" data-aos="fade-left" data-aos-delay="50">
                <div class="sec-title pb-1">
                  <h3 class="technology-title">Best in class for flexibility & ease of use</h3>
                </div>
                <p> We help you create custom web & mobile apps from scratch at the same time we fit very well into teams in order to support Startups and agencies. Because our working style and strategies are transparent with our client.</p>
                <p>Appoint Luvimac as your trusted partner because we help you to achieve your targets in a better, faster and more cost effective way. Everything we do is for customers. We strive to deliver the best customer experience possible. We learn from every project we undertake, continuously striving to improve and reach the next level. This ethos has become part of our culture as we strive to provide the highest quality of service.</p>
                <p> We used to Slack, Trello, Jira, Google, Skype, Zoom for project management and smooth communication</p>
              </div>
            </div>

            <div class="col-lg-6 col-md-6 col-12">
                <div class="d-flex justify-content-center mt-4">
                    <div class="technology-tools d-flex flex-column mt-4" data-aos="fade-up" data-aos-delay="50">
                        <div class="technology-item">
                            <img src="/img/technology/tools/google-icon.svg" alt="html">
                            <div class="technology-name">Google</div>
                        </div>
                        <div class="technology-item">
                            <img src="/img/technology/tools/slack-icon.svg" alt="html">
                            <div class="technology-name">Slack</div>
                        </div>
                    </div>
                    <div class="technology-tools d-flex flex-column" data-aos="fade-down" data-aos-delay="50">
                        <div class="technology-item">
                            <img src="/img/technology/tools/trello-icon.svg" alt="html">
                            <div class="technology-name">Trello</div>
                        </div>
                        <div class="technology-item">
                            <img src="/img/technology/tools/jira.png" alt="html">
                            <div class="technology-name">Jirs</div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
      </div>
    </section>
    </div>
</template>
<script>
import Pagetitle from '../../components/Pagetitle';
import technologymetadata from '../../../metadata/technology.json'
export default { 
  components:{
    Pagetitle,
  },
  data(){
        return{
        metadata:technologymetadata
        }
    },
    metaInfo() {
        return { 
            title: this.metadata.title,
            link:[{ rel:"canonical", href: window.location.href}],
            meta: [
            { name: 'description', content: this.metadata.description},
              { name: 'keyword', content: this.metadata.keyword},
              { name: 'twitter:title', content: this.metadata.twitter_title},
              { property: 'og:title', content: this.metadata.og_title},
              { property: 'og:description', content: this.metadata.og_description},
              {property: 'og:url', content: window.location.href}
            ]
        }
    }
};
</script>

<style lang="scss" scoped>
  .get-started{
    position: relative;
    background:url(/img/about/get-started.jpg);
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    &:after{
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(20, 22, 24, 0.65);
      z-index: 1;
    }
    .box-container{
      max-width: 866px;
      width: 100%;
      position: relative;
      z-index: 2;
      padding: 50px;
      background: rgba(255, 255, 255, 0.1);
      box-shadow: 0 0 20px rgba(0,0,0,0.1);
      border-radius: 15px;
      }
  }
  .technology {
    overflow: hidden;
  }
.mobile-app-developement{
  .technology-tools {
    width: 50%;
    .technology-item {
      width: 96%;
      text-align: left;
      padding: 30px;
      img {
        margin-bottom: 15px;
        width: 80px;
      }
      .technology-name {
          font-size: 20px;
          line-height: 28px;
          color: var(--font-stl-one);
          font-weight: 600;
          margin-bottom: 18px;
      }
      .text {
        color:var(--font-stl-one);
      }
    }
  }
  .mobiles-animation {
    position: relative;
    img {
      width: 100%;
    }
    .mobile-tech-img {
        display: flex;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
          figure.mobile-img {
              position: absolute;
              &.one {
                left: 33%;
                top: 50%;
                transform: translate(-50%, -50%);
                img {
                width: 100%;
                }
              }
              &.two {
                width: 50%;
                left: 73%;
                top: 52%;
                transform: translate(-50%, -50%);
                img {
                width: 100%;
                }
              }        
          }
    }
  }
}

  .technology-tools {
    .technology-item {
        width: 46%;
        text-align:center;
        transition: all .3s ease-in-out;
        // border: 0px solid;
        padding: 30px;
        border-radius: 10px;
        margin: 5px;
        box-shadow: 0px 0px 2px;
        min-width: 150px;
        color: var(--font-stl-one);
         &:hover {
            img {
              transform: scale(1.1);
              transition: all .3s ease-in-out;
          }
         }
        img {
            width: 80px;
            transform: scale(1);
            transition: all .3s ease-in-out;
        }
        .technology-name {
            font-size: 18px;
            font-weight: 600;
            margin-top: 10px;
            color: var(--font-stl-one);;
        }
    }
  }
  .technology-title {
      font-size: 35px;
  }

  @media screen and (max-width:480px) {
    .mobile-app-developement{
      .technology-tools {
        width: 50%;
        .technology-item {
          padding: 15px;
          img {
            margin-bottom: 10px;
            width: 50px;
          }
          .technology-name {
              margin-bottom: 10px;
          }
        }
      }
      .mobiles-animation {
      .mobile-tech-img {
        figure.mobile-img {
              &.one {
                left: 35%;
                width: 55%;
              }
      }
    }
  }
    }
    
    .web-development {
      .technology-tools {
        .technology-item {
          min-width: 130px;
          padding: 20px;
        }
      }
    }
  }
  @media screen and (max-width:375px) {
    .mobile-app-developement{
      .image-section {
        flex-direction: column;
        .technology-tools {
          width: 100%;
          margin-top: 0 !important;
          .technology-item {
            padding: 15px;
            img {
              margin-bottom: 10px;
              width: 50px;
            }
            .technology-name {
                margin-bottom: 10px;
            }
          }
        }
      }
    }
  }
</style>